export const fontSizeList = [
    { id: 0, value: '10', name: '10' },
    { id: 1, value: '12', name: '12' },
    { id: 2, value: '14', name: '14' },
    { id: 3, value: '16', name: '16' },
    { id: 4, value: '18', name: '18' },
    { id: 5, value: '20', name: '20' },
    { id: 6, value: '22', name: '22' },
    { id: 7, value: '24', name: '24' },
    { id: 8, value: '28', name: '28' },
    { id: 9, value: '36', name: '36' },
    { id: 10, value: '48', name: '48' },
    { id: 11, value: '72', name: '72' },
  ];
export const fontSizeList_8_72 = [
    { id: 101, value: '8', name: '8' },
    { id: 102, value: '9', name: '9' },
    ...fontSizeList
  ];
export const fontSizeList_8_72_2 = [
    { id: 101, value: '8', name: '8' },
    { id: 102, value: '9', name: '9' },
    { id: 0, value: '10', name: '10' },
    { id: 103, value: '11', name: '11' },
    { id: 1, value: '12', name: '12' },
    { id: 2, value: '14', name: '14' },
    { id: 3, value: '16', name: '16' },
    { id: 4, value: '18', name: '18' },
    { id: 5, value: '20', name: '20' },
    { id: 6, value: '22', name: '22' },
    { id: 7, value: '24', name: '24' },
    { id: 104, value: '26', name: '26' },
    { id: 8, value: '28', name: '28' },
    { id: 9, value: '36', name: '36' },
    { id: 10, value: '48', name: '48' },
    { id: 11, value: '72', name: '72' },
];
